export default {
    'export': 'تصدير',
    'export-as-excel': 'تصدير إكسل',
    'print-the-account-custom-statement': 'طباعة كشف حساب مُخصص',
    'custom-statements': 'كشوفات مُخصصة',
    'balanced-accounts-only': 'الحسابات ذات الأرصدة فقط',
    'show-all-columns': 'إظهار كل الأعمدة',
    refresh: 'تحديث',

    'total-debit-balance': 'مجموع رصيد مدين:',
    'total-credit-balance': 'مجموع رصيد دائن:',
    'total-difference-balance': 'فرق المجموع:',
    headers: {
        'account-no': 'رقم الحساب',
        'account-name': 'اسم الحساب',
        'parent-account': 'الحساب الرئيسي',
        'debit-balance': 'رصيد مدين',
        'credit-balance': 'رصيد دائن',
        'last-debit-amount': 'أخر حركة مدينة',
        'last-debit-date': 'تاريخ أخر حركة مدينة',
        'last-credit-amount': 'أخر حركة دائنة',
        'last-credit-date': 'تاريخ أخر حركة دائنة',
    },

    'sum-debit-credit-result-headers': {
        'sum-debits': 'مجموع مدين',
        'sum-credits': 'مجموع دائن',
        'debit-balance': 'رصيد مدين',
        'credit-balance': 'رصيد دائن',
    }
}